import { createSlice } from "@reduxjs/toolkit";
import { getDailyOrders } from "./dailyOrdersAction";

const initialState = {
  loading: false,
  error: null,
  success: false,
  dailyProducts: [],
  latestRequestId: null,
};

const dailyOrdersSlice = createSlice({
  name: "dailyOrders",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDailyOrders.pending, (state, action) => {
        state.loading = true;
        state.dailyProducts = [];
        state.error = null;
        state.latestRequestId = action.meta.requestId;
      })
      .addCase(getDailyOrders.fulfilled, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.loading = false;
        state.dailyProducts = action.payload;
        state.error = null;
      })
      .addCase(getDailyOrders.rejected, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export default dailyOrdersSlice.reducer;
